const namespace = {
  sidebar: {
    header: {
      title: "Local Content",
      backAction: "Retour au menu",
      toggle: {
        ariaLabel: "Basculer le menu des scores",
        ariaLabel_open: "Ouvrir le menu des scores",
        ariaLabel_close: "Fermer le menu des scores",
      },
    },
  },
  categoriesToggle: {
    toggleLabel: "Catégories",
    backAction: "Retour",
  },
  categories: {
    commute: "Transport",
    amenities: "Services",
    character: "Caractère",
    nature: "Nature",
    education: "Éducation",
    wellness: "Bien-être",
  },
  scoreMetroComparison: {
    text: "Comparable à la moyenne métropolitaine de {{metroScoreValue}}",
    text_higher: "Supérieur à la moyenne métropolitaine de {{metroScoreValue}}",
    text_lower: "Inférieur à la moyenne métropolitaine de {{metroScoreValue}}",
  },
  poiList: {
    subcategoriesTitle: "Sélectionner une sous-catégorie",
    subcategoriesTitle_transit_friendly: "Sélectionner le type de transport",
    subcategoriesTitle_groceries: "Sélectionner le type de magasin",
    subcategoriesTitle_restaurants: "Sélectionner le type de restaurant",
    subcategoriesTitle_wellness: "Sélectionner le type de service",
    searchRadius: "Affichage des PO dans un rayon de {{radius}} {{unit}}",
  },

  results: {
    none: "Désolé, il n'y a pas de résultats pour cette recherche dans le rayon spécifié autour de l'emplacement sélectionné.",
    limited: "Résultats limités pour cette recherche dans un rayon de",
  },
  commuteCalculator: {
    type: {
      pedestrian: "En marchant",
      car: "En conduisant",
    },
    placeholder: "Faire une recherche...",
    cta: "Calculer le trajet",
    ctaShort: "Calculer",
    results: {
      noRoute: "Aucun itinéraire disponible.",
      trySuggestion: "Essayez une autre requête.",
      fastestRoute: "Itinéraire le plus rapide",
    },
  },

  // Deprecate with LocalContentDeprecated
  scores: {
    location: "Ce Lieu",
    average: "{{type}} Moy.",
    city: "Ville",
    neighborhood: "Quartier",
  },

  // Deprecate with LocalContentDeprecated
  tabs: {
    commute: "Transport",
    amenities: "Services",
    character: "Caractère",
    nature: "Nature",
    education: "Éducation",
    wellness: "Bien-être",
  },
} as const;

export default namespace;
